module.exports = __webpack_public_path__ + "static/media/Windrunner.688c7a65.png";